import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { ToastContainer } from 'react-toastify';
import {errorMesg} from './../../Pages/Toaster';

import {updatePasswordAPI} from "./../../API/Caller/ProfileAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";


const CallerPasswordUpdate = () =>{

    //const [loading, setLoading] = useState(false);
    const [oldpassword, setOldPassword] = useState("");
    const [newpassword, setNewPassword] = useState("");
    const [confirmpassword, setConfirmPassword] = useState("");
    const [btnloader, setBtnLoader] = useState(false);

    useEffect(() => {

        //getProfileDataAPI(setName, setEmail, setContact, setUsername, setAddress, setCity, setState, setPincode, setImage);

    }, []);

    const handleSetOldPassword = (e) =>{
        setOldPassword(e.target.value);
    }

    const handleSetNewPassword = (e) =>{
        setNewPassword(e.target.value);
    }

    const handleSetConfirmPassword = (e) =>{
        setConfirmPassword(e.target.value);
    }

    const handleUpdatePassword = (e) =>{
        e.preventDefault();

        if(oldpassword === "")
        {
            errorMesg("Please enter your old password");
            return;
        }

        if(newpassword === "")
        {
            errorMesg("Please enter your new password");
            return;
        }

        if(confirmpassword === "")
        {
            errorMesg("Please enter your confirm password");
            return;
        }

        if(newpassword !== confirmpassword)
        {
            errorMesg("Confirm password does not match");
            return;
        }


        const formdata = new FormData();
        formdata.append('oldpassword', oldpassword);
        formdata.append('newpassword', newpassword);
        formdata.append('confirmpassword', confirmpassword);
        

        updatePasswordAPI(formdata, setBtnLoader);

    }
    

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Profile</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="border-bottom mb-3">
                                    <div class="row">
                                        
                                        <div class="mb-3">
                                            <label class="form-label">
                                                Old Password <span class="text-danger">*</span>
                                            </label>
                                            <input type="password" class="form-control" name="oldpasswordinput" autocomplete="off" defaultValue={oldpassword} onChange={handleSetOldPassword} />
                                        </div>

                                        <div class="mb-3">
                                            <label class="form-label">
                                                New Password <span class="text-danger">*</span>
                                            </label>
                                            <input type="password" class="form-control" name="newpasswordinput" autocomplete="off" defaultValue={newpassword} onChange={handleSetNewPassword} />
                                        </div>

                                        <div class="mb-3">
                                            <label class="form-label">
                                                Confirm Password <span class="text-danger">*</span>
                                            </label>
                                            <input type="password" class="form-control" name="confpassword" autocomplete="off" defaultValue={confirmpassword} onChange={handleSetConfirmPassword} />
                                        </div>
                                        
                                    </div>
                                </div>
                                
                                <div>
                                    
                                    <button type="button" className="btn btn-primary"  onClick={handleUpdatePassword}>
                                        {btnloader ?
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        :
                                            <p>Update Password</p>
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <ToastContainer />
    </div>
    )
}

export default CallerPasswordUpdate;